/* 
* @Description: 描述
* @Author: D
* @Date: 2024-04-09 14:16
* @LastEditTime: 2024-04-09 17:07
* @LastEditors: D
* @FilePath: \web\src\api\Auction\index.js
*/
import request from '@/utils/request'

// 查询近期拍卖会
export function getFindSysConfigAuctions(params) {
    return request({
        url: '/front/sysconfig/findSysConfigAuctions',
        method: 'GET',
        params
    })
}
//拍卖会详情
export function getFindSysConfigAuctionsInfo(data) {
    return request({
        url: '/front/auction/info',
        method: 'post',
        data
    })
}

/**
 * 查看所有拍卖会
 */
export function findSysConfigAuctionCarList(params) {
    return request({
        url: '/front/sysconfig/findSysConfigAuctionCarList',
        method: 'GET',
        params
    })
}
